<template>
  <section id="patient-case-information-view" class="case-creation" v-loading="loading">
    <div class="order-status-reason" v-if="
      this.getEMRWithIssuesDataById &&
      this.getEMRWithIssuesDataById.issues &&
      this.getEMRWithIssuesDataById.issues.length
    ">
      <div class="container-sm">
        <div class="bg-white">
          <ul>
            <li>
              <h4 class="reason-heading">Issues :</h4>
            </li>
            <li v-for="(issue, index) in this.getEMRWithIssuesDataById.issues" :key="index">
              <p>{{ issue.key }} : {{ issue.message }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-view-information" v-if="getEMRWithIssuesDataById">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
                </span>
                <h3 class="title">Patient Information</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0 mb-15">
              <el-row>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">First Name</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? convertToUppercase(
                            getEMRWithIssuesDataById.patient_info.first_name
                          )
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Last Name</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? convertToUppercase(
                            getEMRWithIssuesDataById.patient_info.last_name
                          )
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Gender</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.gender
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Date of Birth</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? formatDate(
                            getEMRWithIssuesDataById.patient_info
                              .date_of_birth
                          )
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">EMR #</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.emr
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Mobile Number</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.home_phone
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.work_phone
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Email</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.email
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Address Line 1</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.address_line_1
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Address Line 2</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.address_line_2
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Zip</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.zip
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">State</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.state
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">City</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info
                          ? getEMRWithIssuesDataById.patient_info.city
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12" v-if="
                  getEMRWithIssuesDataById.patient_info &&
                  getEMRWithIssuesDataById.patient_info.pregnant
                ">
                  <div class="input-value view-cases">
                    <h4 class="name">Pregnancy</h4>
                    <p class="value">
                      {{
                        getEMRWithIssuesDataById.patient_info.pregnant
                          ? "Yes"
                          : "No"
                      }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <span class="case-creation__divider"></span>
        <div class="case-creation__step case-creation__patient-information">
          <div class="case-creation__card">
            <div class="case-view-information">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img src="@/assets/images/icons/icon-case-info.svg" alt="icon" class="img-fluid" />
                  </span>
                  <h3 class="title">Case Information</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <el-row>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value view-cases"
                      v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.case_types">
                      <h4 class="value">Case Type</h4>
                      <ul v-for="(
caseType, index
                        ) of getEMRWithIssuesDataById.case_types" :key="index">
                        <li>{{ caseTypeMap[caseType] }}</li>
                      </ul>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value" v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.lab">
                      <h4 class="name">Laboratory</h4>
                      <p class="value">
                        {{
                          getEMRWithIssuesDataById.lab
                            ? getEMRWithIssuesDataById.lab.name
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value">
                      <h4 class="name">Ordering Facility</h4>
                      <p class="value" v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.hospital">
                        {{
                          getEMRWithIssuesDataById.hospital &&
                            getEMRWithIssuesDataById.hospital.name
                            ? getEMRWithIssuesDataById.hospital.name
                            : ""
                        }}
                      </p>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value">
                      <h4 class="name">Ordering Facility Branch</h4>
                      <p class="value" v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.hospital_branch">
                        {{
                          getEMRWithIssuesDataById.hospital_branch
                            ? getEMRWithIssuesDataById.hospital_branch
                              .display_name
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value">
                      <h4 class="name">Ordering Physician</h4>
                      <p class="value" v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.ordering_physician">
                        {{
                          getEMRWithIssuesDataById.ordering_physician &&
                            getEMRWithIssuesDataById.ordering_physician.name
                            ? getEMRWithIssuesDataById.ordering_physician.name
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="4" :md="8" :sm="8" :xs="8">
                    <div class="input-value" v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.billing_type">
                      <h4 class="name">Bill To</h4>
                      <p class="value">
                        {{ getEMRWithIssuesDataById.billing_type }}
                      </p>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value view-cases"
                      v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.collection_date">
                      <h4 class="name">Collection Date</h4>
                      <p class="value">
                        {{
                          getEMRWithIssuesDataById.collection_date
                            ? momentWithTimezoneTime(
                              getEMRWithIssuesDataById.collection_date,
                              "MM-DD-yyyy hh:mm A"
                            )
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value view-cases"
                      v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.received_date">
                      <h4 class="name">Received Date</h4>
                      <p class="value">
                        {{
                          getEMRWithIssuesDataById.received_date
                            ? momentWithTimezoneTime(
                              getEMRWithIssuesDataById.received_date,
                              "MM-DD-yyyy hh:mm A"
                            )
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>
                  <el-col :xl="14" :lg="14" :md="12" :sm="12" :xs="12">
                    <div class="input-value">
                      <h4 class="name">ICD-10 ( Indicative )</h4>
                      <p v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.icd_10_codes" class="icd-code value"
                        v-html="getEMRWithIssuesDataById.icd_10_codes &&
                          getEMRWithIssuesDataById.icd_10_codes.length > 0
                          ? printICDCode(
                            getEMRWithIssuesDataById.icd_10_codes
                          )
                          : '--'
                          "></p>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="8" :md="12">
                    <div class="input-value view-cases">
                      <div class="speciment-type-view" v-if="
                        getEMRWithIssuesDataById &&
                        getEMRWithIssuesDataById.sample_types
                      ">
                        <div>
                          <h4 class="name">Specimen Types</h4>
                          <ul class="case_type" v-if="
                            getEMRWithIssuesDataById.sample_types &&
                            getEMRWithIssuesDataById.sample_types.length
                          ">
                            <li class="value" v-for="(
sampleType, index
                              ) in getEMRWithIssuesDataById.sample_types" :key="index">
                              <span>
                                {{ caseTypeMap[sampleType.case_type] }}
                              </span>
                            </li>
                          </ul>
                          <ul v-else>
                            --
                          </ul>
                        </div>
                        <div>
                          <h4 class="name">&nbsp;</h4>
                          <ul class="speciment_type" v-if="
                            getEMRWithIssuesDataById.sample_types &&
                            getEMRWithIssuesDataById.sample_types.length
                          ">
                            <li v-for="(
sampleType, index
                              ) in getEMRWithIssuesDataById.sample_types" :key="index">
                              <span v-if="
                                sampleType.sample_types &&
                                sampleType.sample_types.length
                              ">
                                <span v-for="(
sample, index
                                  ) in sampleType.sample_types" :key="index">
                                  {{ sample }}
                                  <span v-if="
                                    index + 1 < sampleType.sample_types.length
                                  ">,</span>
                                </span>
                              </span>
                              <span v-else> -- </span>
                            </li>
                          </ul>
                          <ul v-else>
                            --
                          </ul>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                    <div class="input-value">
                      <h4 class="name">Order Codes</h4>
                      <ul class="order_code" v-if="
                        getEMRWithIssuesDataById &&
                        getEMRWithIssuesDataById.order_codes &&
                        getEMRWithIssuesDataById.order_codes.length
                      ">
                        <li class="totalList">
                          <div class="eachList" v-for="orderCode in getEMRWithIssuesDataById.order_codes"
                            :key="orderCode.order_code">
                            {{ orderCode.order_code }} ::
                            {{
                              orderCode.description
                            }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                    <div class="input-value view-cases"
                      v-if="getEMRWithIssuesDataById && getEMRWithIssuesDataById.emr_notes">
                      <h4 class="name">EMR Notes</h4>
                      <p class="value">
                        {{
                          getEMRWithIssuesDataById.emr_notes &&
                            getEMRWithIssuesDataById.emr_notes.length &&
                            getEMRWithIssuesDataById.emr_notes[0]
                            ? getEMRWithIssuesDataById.emr_notes[0]
                            : "--"
                        }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
        <span class="case-creation__divider"></span>
        <div>
          <ErequisitionForm></ErequisitionForm>
        </div>
        <span class="case-creation__divider" v-if="hasBillingType"></span>
        <div v-if="hasBillingType">
          <BillingInformation></BillingInformation>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import HospitalHelper from "@/mixins/HospitalHelper";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import caseConstants from "@/config/constants/caseConstants";
const ErequisitionForm = defineAsyncComponent(() =>
  import("@/components/EMROrders/Erequisition")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/EMROrders/BillingInformationIssues")
);
export default {
  components: {
    ErequisitionForm,
    BillingInformation
  },
  mixins: [
    AppHelper,
    UserPermissionsHelper,
    HospitalHelper,
    caseDataHelper,
    InsuranceHelper,
  ],
  computed: {
    ...mapGetters("emrOrders", ["getEMRWithIssuesDataById"]),
    hasBillingType() {
      if (
        this.getEMRWithIssuesDataById &&
        this.getEMRWithIssuesDataById.billing_type &&
        this.getEMRWithIssuesDataById.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  async mounted() {
    if (this.$route.params.order_id) {
      await this.fetchEmrwithIssues();
    }
  },
  methods: {
    printICDCode(icd_code) {
      let formatted_icd_code = "";
      for (let i = 0; i < icd_code.length; i++) {
        formatted_icd_code += "<span> " + icd_code[i] + "</span>";
      }
      return formatted_icd_code;
    },
    async fetchEmrwithIssues() {
      try {
        let params = {
          emr_id: this.$route.params.order_id,
        };
        await this.$store.dispatch("emrOrders/fetchEMRWithIssuesById", params);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss">
.order-status-reason {
  margin-bottom: 5px;

  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {
      position: relative;

      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }

          color: #333;
        }
      }

      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }

      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
</style>